<template>
  <div>
    <Card title="Video Page Section">
      <template v-slot:button>
        <Button variant="primary" label="Add Section" @clicked="add" />
      </template>
      <template v-slot:body>
        <el-table-draggable @sort="onSort"  handle=".handle-move" >
          <el-table :data="listSections" row-key="id" :show-header="true" style="width: 100%">
            <el-table-column label="" align="center" key="handle">
              <div class="static inline-block text-center container-action handle-move" style="cursor: move">
                <font-awesome-icon size="2x" :icon="['fa', 'th']" />
              </div>
            </el-table-column>
            <el-table-column v-for="column in tableColumn" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Status" class="text-center" >
              <template slot-scope="scope">
                <label
                  :for="'toogle'+scope.row.id"
                  class="flex items-center"
                  :class="'cursor-pointer'"
                  style="height: 50px;"
                >
                  <!-- toggle -->
                  <div class="relative m-auto">
                    <!-- input -->
                    <input
                      :id="'toogle'+scope.row.id"
                      v-model="scope.row.published"
                      @change="setStatusSection(scope.row)"
                      type="checkbox"
                      class="hidden"
                    />
                    <!-- line -->
                    <div
                      class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    ></div>
                    <!-- dot -->
                    <div
                      class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    ></div>
                  </div>
                  <!-- label -->
                </label>
              </template>
            </el-table-column>
            <el-table-column label="Actions" align="right">
              <template v-slot="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Detail" :position="'is-left'">
                    <router-link :to="{ name: 'VideoPageDetail', params: { sectionId: scope.row.id }}">
                      <a  class="p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                        <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                      </a>
                    </router-link>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Edit" :position="'is-left'">
                    <a @click="edit(scope.row)" class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                    </a>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Delete" :position="'is-left'">
                    <button @click="deleteSection(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-table-draggable>
      </template>
    </Card>
    <ModalDialog
      ref="sectionForm"
      :isShowingModal="isShowingModal"
      :title="titleModal"
      @toggleModal="isShowingModal = !isShowingModal"
      :labelSubmit="'Submit'"
      @save="submitForm()" >
      <template slot="body" >
        <form class="flex w-full overflow-x-hidden" id="form-activity" autocomplete="off" >
          <div class="w-full p-2" >
            <form-item label="Name">
              <Input
                v-model="input.name"
                placeholder="ex. Section Name"
                :error="$v.input.name.$dirty && (!$v.input.name.required)"
              />
              <div class="flex flex-col pt-2">
                <text-error v-if="$v.input.name.$dirty && !$v.input.name.required" text="Please fill name." />
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import Vue from 'vue';
import ElTableDraggable from 'el-table-draggable';
import ModalDialogDetail from '@/components/Common/ModalDialogDetail';
import ModalDialog from '@/components/Common/ModalDialog';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { Button, FormItem, Input, TextError } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

export default {
  name: 'VideoPageSection',
  mixins: [validationMixin],
  data: () => ({
    listSections: [],
    isShowingModal: false,
    isEdit: false,
    input: {
      id: null,
      name: '',
      total_content: 0,
    },
    tableColumn: [
      {
        prop: 'name',
        label: 'Name',
      },

    ],
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('VideoPageModule', ['listSection']),
    titleModal() {
      return this.isEdit ? 'Edit Section' : 'Add Section';
    },
  },
  validations() {
    return {
      input: {
        name: { required },
      },
    };
  },
  async mounted() {
    await this.requestListSection();
  },
  methods: {
    ...mapActions('VideoPageModule', ['requestListSection', 'requestCreateSection',
      'requestReorderSection', 'requestDeleteSection', 'requestEditSection','requestPublishSection']),
    add() {
      this.isEdit = false;
      this.input = { ...this.input, id: null, name: ''};
      this.resetForm();
      this.isShowingModal = true;
    },
    edit(row) {
      this.isEdit = true;
      this.input = { ...this.input, id: row.id, name: row.name};
      this.resetForm();
      this.isShowingModal = true;
    },
    resetForm() {
      this.$v.$reset();
    },
    async submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isShowingModal = !this.isShowingModal;
        const data = {
          name: this.input.name,
        };
        if (!this.isEdit) {
          await this.requestCreateSection(data);
        } else {
          await this.requestEditSection({ ...data,id: this.input.id });
        }
      }
    },
    async onSort(evt) {
      setTimeout(async () => {
        const ids = this.listSections.map(play => play.id);
        await this.requestReorderSection({
          ids: ids,
        });
      }, 500);
    },
    async setStatusSection(section) {
      const status = {
        id: section.id,
        published: section.published,
      };
      await this.requestPublishSection(status);
    },
    async deleteSection(section) {
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete section: ${section.title}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteSection({id:section.id});
          this.$swal('Deleted', `You successfully delete section: ${section.name}`, 'success');
        }
      });
    },
  },
  watch: {
    listSection: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (this.listSection) {
          this.listSections = this.listSection.map(s => ({ ...s, published: (!!s.published) }));
        }
      },
    },
  },
  components: {
    ElTableDraggable, VueCustomTooltip, ModalDialogDetail, ModalDialog,
    Button,
    Card,
    FormItem, Input, TextError
  },
};
</script>

<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/VideoPage/VideoPageSection.vue